import { Button, type ButtonProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import Tippy from './Tippy'

// To avoid confusion omitting disabled prop in favor of isDisabled prop
export const TooltipButton = ({
  tooltipContent,
  children,
  ...buttonProps
}: Omit<ButtonProps, 'disabled'> & { tooltipContent: string | ReactNode }) => (
  <Tippy content={tooltipContent} disabled={buttonProps.isDisabled !== true}>
    <Button {...buttonProps}>{children}</Button>
  </Tippy>
)

export default TooltipButton
